module.exports = __webpack_public_path__ + "static/media/four-columns.1f2969df.jpg";